module.exports = __webpack_public_path__ + "static/media/Gotham-Book.ac83c9fc.woff";